import { useState } from "react";
import { api } from "../../../lib/api";
import { toast } from "sonner";
import { Loader2 } from "lucide-react";
import { STAGES, normStage, stageIndex } from "../pipeline";

export function PipelineBar({ kind, idOrRef, stage, canManage, onChanged }) {
  const [busy, setBusy] = useState(false);
  const idx = stageIndex(stage);

  const move = async (next) => {
    if (!next || next === normStage(stage)) return;
    setBusy(true);
    try {
      const r = await api.put("/admin/prospect/stage", { kind, id_or_ref: idOrRef, stage: next });
      toast.success(`Stage → ${STAGES.find(s => s.key === next)?.label || next}`);
      if (onChanged) onChanged(r.data.stage);
    } catch (e) { toast.error(e?.response?.data?.detail || "Could not update stage"); }
    setBusy(false);
  };

  return (
    <div className="border border-[#E5E7EB] bg-white px-3 py-2.5 mb-4" data-testid="pipeline-bar">
      <div className="flex items-center justify-between gap-3 flex-wrap">
        <div className="flex items-center flex-wrap" data-testid="pipeline-stages">
          {STAGES.map((s, i) => (
            <div key={s.key} className="flex items-center">
              {i > 0 && <div className={`w-2.5 h-0.5 ${i <= idx ? "bg-[#C79A3B]" : "bg-[#E5E7EB]"}`} />}
              <span data-testid={`pipeline-stage-${s.key}`}
                className={`px-1.5 py-1 text-[9px] font-black uppercase tracking-widest rounded-full whitespace-nowrap ${
                  i < idx ? "bg-[#D8EED8] text-[#1F6B3B]" : i === idx ? "bg-[#12263A] text-white" : "bg-[#F0EAE0] text-[#9CA3AF]"}`}>
                {s.label}{i < idx ? " ✓" : ""}
              </span>
            </div>
          ))}
        </div>
        {canManage && (
          <label className="flex items-center gap-1.5 text-[10px] uppercase tracking-widest font-bold text-[#6B7280] shrink-0">
            {busy ? <Loader2 size={12} className="animate-spin" /> : "Move to"}
            <select data-testid="pipeline-move-select" value={normStage(stage)} disabled={busy}
              onChange={(e) => move(e.target.value)}
              className="border border-[#E5E7EB] px-2 py-1 text-xs font-bold bg-white text-[#12263A]">
              {STAGES.map(s => <option key={s.key} value={s.key}>{s.label}</option>)}
            </select>
          </label>
        )}
      </div>
      <p className="text-[10px] text-[#9CA3AF] mt-1.5">Stages auto-advance on key events (booking, survey, job confirmed, build, complete) — use the dropdown to override manually.</p>
    </div>
  );
}
